import RtLookup from './rtLookup';

export default RtLookup;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/lookup/index.js